/** Validated public environment (FE-01 §7.2, FR-FE01-29). Secrets are never VITE_* variables. */
import { type Env, parseEnv } from "./envSchema";

export type { AppEnv, Env } from "./envSchema";

export const env: Env = parseEnv(
  import.meta.env as Record<string, string | undefined>,
  window.location.origin,
);
